<template>
  <div>
    <h1>u/{{ username }}@{{ domain }}</h1>
    <h2>{{ user.disp_name }}</h2>
    <img :src="gravatarUrl" alt="User Avatar" class="avatar" />
    <p v-html="user.bio"></p>
    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <ul v-else>
      <li v-for="article in articles" :key="article.id">
        <h2>{{ article.Title }}</h2>
        <p>Abstract: <i>{{ article.Abstract }}</i></p>
        <p>Author: {{ article.AuthorName }}</p>
        <p>Published on: {{ article.CreatedAt }}</p>
        <p>CID: <a :href="`https://ipfs.io/ipfs/${article.CID}`">{{ article.CID }}</a></p>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import md5 from 'md5';
import config from '../config';

const articles = ref([]);
const domain = new URL(window.location.origin).hostname;
const user = ref({});
const gravatarUrl = ref("");
const loading = ref(true);
const error = ref(null);
//const username = sessionStorage.getItem('username');
const route = useRoute();
const username = ref(route.query.username || "");
const token = sessionStorage.getItem("jwt");

const fetchArticles = async () => {
  try {
    const response = await fetch(`${ config.apiBaseUrl }/articles/personal/${ username.value }`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    }); // Replace with your actual API endpoint
    if (!response.ok) {
      throw new Error('Failed to fetch articles');
    }
    const data = await response.json();
    articles.value = data;
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};

const fetchUser = async () => {
  try {
    const response = await fetch(`${ config.apiBaseUrl }/users/${ username.value }`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${token}`, // Include JWT in the Authorization header
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch user data');
    }
    const data = await response.json();
    user.value = data;
    gravatarUrl.value = `https://www.gravatar.com/avatar/${md5(user.value.email.trim().toLowerCase())}?s=200&d=identicon`;
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  loading.value = true;
  await Promise.all([fetchUser(), fetchArticles()]); // Run both in parallel
  loading.value = false;
});

</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
